export default __webpack_public_path__ + "static/media/the_bear.ea7089c9.jpg";